import { render } from "./BlogTwo.vue?vue&type=template&id=07b52be8&scoped=true"
import script from "./BlogTwo.vue?vue&type=script&lang=js"
export * from "./BlogTwo.vue?vue&type=script&lang=js"

import "./BlogTwo.vue?vue&type=style&index=0&id=07b52be8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b52be8"]])

export default __exports__